// extracted by mini-css-extract-plugin
export default {"palette":"Palette_palette__6+h2R","paletteColors":"Palette_paletteColors__8wVRf","paletteFooter":"Palette_paletteFooter__mQbgG","emoji":"Palette_emoji__kys5C"};